export const DEFAULT_VRAM_KB = 500000
